module.exports = __webpack_public_path__ + "static/media/AssignManagerPermissions.b4d08036.svg";